import { inject, Injectable, signal } from '@angular/core';
import { ServicesService } from '../app/api/api/services.service';
import { LanguagesService } from '../app/api/api/languages.service';
import { ModelsService } from '../app/api/model/models';
import { ModelsLanguage } from '../app/api/model/modelsLanguage';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistryService {
  private servicesApi = inject(ServicesService);
  private languagesApi = inject(LanguagesService);

  public services = signal<ModelsService[]>([]);
  public languages = signal<ModelsLanguage[]>([]);
  public loaded = signal(false);

  async loadServices() {
    try {
      const [servicesResponse, languagesResponse] = await Promise.all([
        firstValueFrom(this.servicesApi.apiServicesGet(true)),
        firstValueFrom(this.languagesApi.apiLanguagesGet())
      ]);

      if (servicesResponse && (servicesResponse as any).data) {
        this.services.set((servicesResponse as any).data as ModelsService[]);
      }

      if (languagesResponse && languagesResponse.data) {
        this.languages.set(languagesResponse.data);
      }

      this.loaded.set(true);
    } catch (error) {
      console.error('Failed to load registry data', error);
      throw error;
    }
  }
}
